













































































import { Component, Prop, Watch } from 'vue-property-decorator';
import BaseCalendarVue, { CalendarEvent, TimeSchedule } from './baseCalendar.vue';
import { Schedule } from '@/modules/studentCalendar';

@Component
export default class extends BaseCalendarVue {
  public dateFormat(date: Date): string {
    return (
      `<span style="display: inline-block;">${date.getFullYear()}年</span>` +
      `<span style="display: inline-block;">${date.getMonth() + 1}月` +
      `<span style="display: inline-block;">${date.getDate()}日</span></span>`
    );
  }

  private getCellClassName(time: number) {
    const isStart = time.toString().indexOf('.') < 0;
    if (isStart) { return 'start'; }
    return 'end';
  }

  private getHtml(schedule: TimeSchedule) {
    return schedule.endTimeIndex - schedule.startTimeIndex > 0 ?
      schedule.weekLongHtml :
      schedule.weekShortHtml;
  }

  private clickTag(date: Date) {
    this.$emit('click-tag', date);
  }
}
